// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"wrapper--vejdn","info":"info--XfdnR","uploadButtons":"uploadButtons--5ZGPn","uploadComponent":"uploadComponent--MlMVF"};